export const articles = [
  {
    id: "1001",
    title: "深夜片场的暖心一幕被拍下，全组订热汤面的故事火出圈",
    excerpt:
      "收工已是凌晨，几位主创却主动留下来帮忙收器材，还给全组订了热汤面，这段幕后片段让不少观众直呼被治愈。",
    category: "star",
    categoryName: "星闻速递",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20film%20set%20backstage%20scene%20at%20night%20with%20soft%20golden%20lighting%2C%20camera%20equipment%20and%20friendly%20crew%20members%20talking%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20tones%2C%20cozy%20atmosphere&width=800&height=600&seq=gu-art-1001&orientation=landscape",
    author: "瓜田观察员",
    date: "2026-09-08",
    views: 128340,
    comments: 862,
    tags: ["剧组动态", "片场花絮", "暖心瞬间"],
    hot: true,
    content: [
      "最近一段来自剧组片场的幕后片段在社交平台上悄悄流传：收工已是深夜，工作人员还在整理器材，几位主创却主动留下来帮忙，还给全组订了热汤面。片段本身没有刻意剪辑，却因为那份自然的松弛感被大量转发。",
      "据现场工作人员分享，这样的画面在这个组里并不是第一次。因为拍摄周期长、夜戏密集，主创之间形成了一个不成文的习惯——谁当天收工早，谁就负责给还在拍摄的伙伴带点吃的，久而久之就成了组里的固定节目。",
      "有网友把这些片段整理成合集，配文写着「原来一部剧的温度，是从片场氛围开始的」。评论区里，不少观众顺势聊起了自己心目中的「剧组氛围感」名场面，讨论热度一路走高。",
      "截至发稿，相关话题仍在持续发酵。我们会继续关注后续花絮，也提醒各位理性吃瓜，把更多注意力留给他们即将与观众见面的作品本身。",
    ],
  },
  {
    id: "1002",
    title: "话题剧收官夜复盘：三个细节藏着主创的小心思",
    excerpt:
      "大结局播出后讨论度居高不下，从片头字幕到最后一帧构图，三处容易被忽略的设计其实早有铺垫。",
    category: "drama",
    categoryName: "剧集热评",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20finale%20scene%20with%20moody%20warm%20lighting%2C%20empty%20director%20chair%20and%20film%20reel%20on%20set%2C%20editorial%20photography%2C%20deep%20amber%20and%20charcoal%20tones&width=800&height=600&seq=gu-art-1002&orientation=landscape",
    author: "追剧不打烊",
    date: "2026-09-07",
    views: 96420,
    comments: 1204,
    tags: ["剧集热评", "大结局", "细节解析"],
    hot: true,
    content: [
      "这部话题剧在收官夜再次冲上讨论榜前列。很多人只记住了最后三分钟的反转，但把全剧再看一遍就会发现，主创其实早在前半段就埋好了线索，只是当时没人往那个方向想。",
      "第一个细节是片头字幕的变化。随剧情推进，片头里的一个背景元素会悄悄发生位移，直到大结局才和最后一帧画面完全对齐，形成视觉上的闭环。",
      "第二个细节藏在配乐里。同一段旋律在前几集以舒缓的弦乐出现，收官时换成了几乎没有伴奏的清唱，情绪落差被拉得很开，不少观众表示就是在这里破防的。",
      "第三个细节则是人物站位。最后一次同框时，两位主角的位置恰好回到了首集开场时的构图，一来一回之间，故事完成了它自己的呼应。这种不靠台词说破的处理，恰恰是它值得反复回味的地方。",
    ],
  },
  {
    id: "1003",
    title: "综艺名场面复盘：一句话让全场安静了三秒",
    excerpt:
      "最新一期节目里出现了罕见的静默时刻，嘉宾脱口而出的一句话，成了整季讨论度最高的瞬间。",
    category: "variety",
    categoryName: "综艺高能",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20studio%20set%20with%20round%20stage%20and%20warm%20spotlights%2C%20empty%20host%20chair%2C%20editorial%20photography%2C%20playful%20orange%20and%20cream%20tones&width=800&height=600&seq=gu-art-1003&orientation=landscape",
    author: "综艺显微镜",
    date: "2026-09-06",
    views: 82150,
    comments: 978,
    tags: ["综艺高能", "名场面", "节目复盘"],
    content: [
      "这一期节目播出后，被反复截取的并不是游戏环节，而是中场休息前的一段聊天。一位嘉宾在玩笑之间突然说出一句真心话，现场瞬间安静了三秒，随后全场笑成一片。",
      "节目组事后在花絮里透露，这三秒并没有被剪掉，是因为导演觉得它「真实得舍不得动」。正是这种没有被修饰的停顿，让观众感受到了久违的松弛。",
      "有意思的是，这段内容在短视频平台被二次创作后，衍生出了各种生活化的版本，从职场到家庭都能套用，也侧面说明了好的综艺片段往往具备跨场景的共鸣能力。",
      "综艺之所以让人上瘾，很多时候不是因为笑点多密集，而是这些意料之外的真实反应。下一期节目预告里已经埋了新的悬念，看来这季的话题还会继续。",
    ],
  },
  {
    id: "1004",
    title: "巡演首站歌单提前曝光，压轴曲目引发全场大合唱",
    excerpt:
      "首站开演前歌单流出，老歌与新作的配比相当讲究，压轴那一首几乎让整个场馆跟着唱了起来。",
    category: "stage",
    categoryName: "舞台现场",
    cover:
      "https://readdy.ai/api/search-image?query=Live%20concert%20stage%20viewed%20from%20the%20audience%20with%20warm%20amber%20stage%20lights%20and%20glowing%20phone%20lights%2C%20cinematic%20editorial%20photography%2C%20rich%20warm%20tones&width=800&height=600&seq=gu-art-1004&orientation=landscape",
    author: "现场第一排",
    date: "2026-09-05",
    views: 74580,
    comments: 654,
    tags: ["巡演", "歌单", "现场"],
    content: [
      "巡演首站开演前，一份疑似歌单在场馆外流传开来。和以往不同的是，这次老歌与新作的配比相当讲究，前半程几乎都是节奏明快的作品，用来带动气氛，中段才缓缓进入慢歌环节。",
      "真正让全场沸腾的是压轴曲目。前奏刚响起，看台上的手机灯光就一片接一片亮了起来，最后几乎所有观众都跟着唱完了整首，主唱干脆把话筒朝向观众，安静听了将近一分钟。",
      "有观众散场后说，这首歌以前在耳机里听过无数遍，但真到现场才发现，原来它的副歌本来就是为大合唱准备的。",
      "巡演还将陆续走进多座城市，我们也会持续更新现场的精彩瞬间。想去现场的朋友，记得提前关注官方渠道的购票信息。",
    ],
  },
  {
    id: "1005",
    title: "红毯造型盘点：今年最出圈的三个配色思路",
    excerpt:
      "与其记住某一条裙子，不如记住配色思路。这三次红毯亮相，把「显气色」这件事讲得很清楚。",
    category: "style",
    categoryName: "红毯穿搭",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20setting%20with%20soft%20warm%20spotlights%2C%20empty%20velvet%20rope%20and%20golden%20accents%2C%20editorial%20fashion%20photography%2C%20cream%20and%20amber%20tones&width=800&height=600&seq=gu-art-1005&orientation=landscape",
    author: "穿搭拆解室",
    date: "2026-09-04",
    views: 68930,
    comments: 512,
    tags: ["红毯造型", "配色", "穿搭"],
    content: [
      "每次活动结束后，红毯造型的讨论总绕不开「谁赢麻了」。但如果换一个角度，比起记住某一条裙子，记住配色思路反而更有实际参考价值。",
      "第一种思路是同色系深浅叠穿。整体保持在温暖色域内，用明度差做出层次，远看干净，近看有细节，也最不容易出错。",
      "第二种思路是用一个高明度的小面积单品做点缀。大面积保持克制，只在配饰或鞋履上放一个亮点，视觉重心一下就立住了。",
      "第三种思路则是低饱和与金属质感的组合。柔和的底色加上一点金属反光，在闪光灯下既有质感又不会显得沉闷，这也是今年出现频率最高的一种处理。",
    ],
  },
  {
    id: "1006",
    title: "本周网友吵翻的话题：追剧到底该不该开倍速",
    excerpt:
      "一个看似简单的问题，却让评论区迅速分成两派。倍速追剧到底是效率还是浪费，双方各有道理。",
    category: "buzz",
    categoryName: "网络热议",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20evening%20scene%20with%20warm%20lamp%20light%20and%20a%20laptop%20playing%20a%20video%20on%20the%20sofa%2C%20editorial%20lifestyle%20photography%2C%20warm%20cream%20tones&width=800&height=600&seq=gu-art-1006&orientation=landscape",
    author: "话题放大镜",
    date: "2026-09-03",
    views: 133760,
    comments: 2410,
    tags: ["热议话题", "追剧", "网友观点"],
    hot: true,
    content: [
      "「追剧到底该不该开倍速」这个老问题，这周又一次被顶上讨论榜。起因是一位网友晒出了自己的观看记录，一部四十集的剧只用了两个晚上看完，评论区迅速分成了两派。",
      "支持倍速的一方认为，现在的剧集普遍存在注水现象，快速略过无关支线并没有损失什么，反而把时间还给了自己。",
      "反对的一方则觉得，节奏本身就是创作者表达的一部分。一段缓慢的长镜头如果被压缩，那种情绪积攒的过程也就跟着消失了，看完之后自然记不住什么。",
      "其实双方的分歧未必在倍速本身，而是在「看剧到底是为了什么」。有人追求信息密度，有人追求沉浸体验，答案本来就不必统一。你属于哪一派？",
    ],
  },
  {
    id: "1007",
    title: "新剧开机路透：主创团队提前半月进组围读剧本",
    excerpt:
      "开机仪式还没正式开始，剧本围读的照片就先流了出来，主创提前半个月进组的做法引发不少讨论。",
    category: "star",
    categoryName: "星闻速递",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20rehearsal%20room%20with%20stacked%20screenplays%20on%20a%20wooden%20table%20and%20warm%20window%20light%2C%20editorial%20photography%2C%20soft%20cream%20and%20amber%20tones&width=800&height=600&seq=gu-art-1007&orientation=landscape",
    author: "瓜田观察员",
    date: "2026-09-02",
    views: 54310,
    comments: 398,
    tags: ["开机", "剧本围读", "剧组动态"],
    content: [
      "新剧开机仪式还没正式开始，一组剧本围读的照片就先在社交平台流了出来。照片里，长桌上一摞摞剧本被翻得起了毛边，主创们低头讨论的侧影被窗光勾出轮廓。",
      "据了解，这次主创团队提前了半个月进组，只做一件事：把剧本从头到尾读一遍，逐场讨论人物动机。有工作人员说，光是第一集就聊了整整一个下午。",
      "这种做法在业内并不算常见。提前围读意味着要额外协调档期和场地，但它能有效减少正式拍摄时的返工，也让演员之间提前建立起默契。",
      "目前该剧仍处于筹备阶段，正式定档信息尚未公布。我们会持续关注后续动态，也期待这部作品能带来不一样的惊喜。",
    ],
  },
  {
    id: "1008",
    title: "没有顶流的小成本剧，凭什么靠口碑一路逆袭",
    excerpt:
      "没有大牌演员、没有铺天盖地的宣传，这部剧却靠着观众的自来水推荐，把讨论度一点点做了起来。",
    category: "drama",
    categoryName: "剧集热评",
    cover:
      "https://readdy.ai/api/search-image?query=Intimate%20small%20drama%20scene%20set%20in%20a%20warm%20lit%20old%20apartment%2C%20vintage%20props%20and%20soft%20afternoon%20light%2C%20editorial%20photography%2C%20cozy%20earth%20tones&width=800&height=600&seq=gu-art-1008&orientation=landscape",
    author: "剧评小站",
    date: "2026-09-01",
    views: 61240,
    comments: 476,
    tags: ["小成本剧", "口碑", "剧评"],
    content: [
      "这部剧刚上线时几乎没有宣传声量，主演阵容也称不上顶流。但播到第二周，社交平台上开始出现大量自发安利，讨论度就这样被一点点做了起来。",
      "它最被称道的地方是台词。编剧没有刻意堆砌金句，而是让对话更贴近生活本来的样子，很多观众说「听着像身边人真的会说的话」。",
      "其次是场景的真实感。剧组没有搭华丽的布景，反而把镜头对准了有生活痕迹的老房子，墙上的水渍、桌上的搪瓷杯，都成了叙事的一部分。",
      "当一部剧把预算花在了对的地方，观众其实是能感受到的。口碑逆袭从来不是运气，而是一次次认真对待细节之后的水到渠成。",
    ],
  },
  {
    id: "1009",
    title: "慢综艺的治愈密码：为什么我们爱看别人做饭聊天",
    excerpt:
      "没有激烈对抗，也没有密集笑点，一档慢综艺却能让观众安静看完。它抓住的其实是都市人稀缺的松弛感。",
    category: "variety",
    categoryName: "综艺高能",
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20countryside%20kitchen%20scene%20with%20warm%20sunset%20light%2C%20fresh%20vegetables%20on%20wooden%20table%20and%20steaming%20pot%2C%20editorial%20photography%2C%20warm%20earthy%20tones&width=800&height=600&seq=gu-art-1009&orientation=landscape",
    author: "综艺显微镜",
    date: "2026-08-31",
    views: 47820,
    comments: 361,
    tags: ["慢综艺", "治愈", "节目观察"],
    content: [
      "一档几乎没有赛制的慢综艺，最近悄悄成了很多人睡前必看的内容。节目内容简单到可以用一句话概括：几个人在乡下的院子里做饭、聊天、发呆。",
      "它之所以能留住观众，恰恰是因为它不急着制造任何东西。镜头愿意花很长时间拍一锅汤慢慢冒泡，也愿意听完一段没有结论的闲聊。",
      "对很多生活在城市里的人来说，这种节奏本身就是稀缺品。看别人把一顿饭认真地做完，某种程度上也是在替自己完成一次放松。",
      "综艺不一定要让人紧张或大笑才算成功。能让观众在一天结束时安静下来，同样是一种难得的本事。",
    ],
  },
  {
    id: "1010",
    title: "音乐节新手攻略：第一次去现场要注意这几件事",
    excerpt:
      "第一次去音乐节，光有热情还不够。从穿搭到站位再到补水，这几条经验能让你玩得更尽兴。",
    category: "stage",
    categoryName: "舞台现场",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20at%20golden%20hour%20with%20a%20large%20crowd%20and%20warm%20stage%20lights%2C%20wide%20editorial%20photography%2C%20warm%20amber%20sky%20tones&width=800&height=600&seq=gu-art-1010&orientation=landscape",
    author: "现场第一排",
    date: "2026-08-30",
    views: 39640,
    comments: 289,
    tags: ["音乐节", "攻略", "现场"],
    content: [
      "每年音乐节季，都会有不少人带着满腔热情第一次走进现场，然后被烈日、人群和漫长的等待狠狠上了一课。提前做点功课，体验真的会好很多。",
      "穿搭上，尽量选择透气、方便活动又不怕脏的衣服和鞋。现场大多是草地或沙地，高跟鞋和纯白球鞋基本等于自找麻烦，一件轻薄的防晒外套反而更实用。",
      "站位的学问也不小。想离舞台近，就得提前一两个小时去前排等着；如果更在意整体氛围，中后区其实是更舒服的选择，视野开阔还能随时去买水。",
      "最后也是最重要的：记得补水和防晒，随身带一小瓶水，感到闷热就及时退到人群外侧透气。玩得开心的前提，永远是照顾好自己。",
    ],
  },
  {
    id: "1011",
    title: "把红毯配色穿进日常：三个普通人也能照搬的思路",
    excerpt:
      "红毯造型离生活并不远，把舞台上的配色逻辑降一个亮度，日常通勤照样能穿出质感。",
    category: "style",
    categoryName: "红毯穿搭",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20warm%20toned%20clothing%20rack%20with%20folded%20knitwear%20and%20a%20wool%20coat%2C%20soft%20natural%20window%20light%2C%20editorial%20fashion%20photography%2C%20beige%20and%20terracotta%20palette&width=800&height=600&seq=gu-art-1011&orientation=landscape",
    author: "穿搭拆解室",
    date: "2026-08-29",
    views: 35210,
    comments: 214,
    tags: ["日常穿搭", "配色", "秋冬"],
    content: [
      "很多人觉得红毯造型只能看看，其实把它的配色逻辑降一个亮度，日常通勤照样能穿出质感。重点从来不是那件礼服本身，而是颜色之间的关系。",
      "最简单的一招是把全身控制在同一个色域里，用深浅不同的两三件单品叠出层次。比如燕麦色外套配奶咖色内搭，整体温和又不单调。",
      "进阶一点，可以在同色系里加入一件低饱和的彩色单品，比如一件砖红或焦糖色的针织衫。它足够醒目，却不会抢走整体的沉稳感。",
      "配饰方面，金属质感的耳饰或腰带是很划算的选择。面积小、提亮快，还能让基础款立刻显得精致，这也是红毯造型里最容易被忽略的一环。",
    ],
  },
  {
    id: "1012",
    title: "热搜是怎么被顶上榜单的：一条话题的传播路径拆解",
    excerpt:
      "从一个词条出现，到登上榜单前列，中间其实经历了多个阶段。了解这套机制，能让你吃瓜时更清醒。",
    category: "buzz",
    categoryName: "网络热议",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20of%20rising%20trending%20lines%20on%20a%20warm%20cream%20background%2C%20minimal%20editorial%20graphic%20style%2C%20amber%20and%20terracotta%20accent%20lines&width=800&height=600&seq=gu-art-1012&orientation=landscape",
    author: "话题放大镜",
    date: "2026-08-28",
    views: 42760,
    comments: 305,
    tags: ["热搜机制", "传播", "吃瓜指南"],
    content: [
      "每天都有新的词条出现在热搜榜上，但很少有人想过，一个话题究竟是怎么从无到有、一步步爬到前列的。了解这套路径，能让你吃瓜时多一分清醒。",
      "通常它的起点是一个足够具体的小事件：一段视频、几句聊天记录，或者一张被反复转发的截图。这个阶段讨论量并不大，但内容本身具备被转述的价值。",
      "接着进入扩散期。第一批转发者往往会加上自己的解读，话题也在此过程中被简化和标签化，从「发生了什么」变成「你怎么看」。",
      "当讨论从事实转向观点，情绪就会成为主要驱动力，热度也随之被推高。这时候再回头看最初的素材，你会发现它和榜上那个词条之间，已经隔了好几层转译。理性吃瓜，本质上就是保留一点溯源的习惯。",
    ],
  },
];